import { render, staticRenderFns } from "./ProvidingDataAgreementText.vue?vue&type=template&id=c6b71caa&scoped=true&"
import script from "./ProvidingDataAgreementText.vue?vue&type=script&lang=ts&"
export * from "./ProvidingDataAgreementText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b71caa",
  null
  
)

export default component.exports